import { Button, cx } from "./ui";
import { fmtNumber } from "@/lib/format";

import { t } from "@/lib/i18n";
/** Seiten blättern – einheitlich für alle Listen: „1–100 von 12.480“, Zurück/Weiter, optional Seitengröße */
export function Pager({ total, page, pageSize, onPage, sizes, onPageSize, className }: {
  total: number;
  page: number;
  pageSize: number;
  onPage: (page: number) => void;
  sizes?: number[];
  onPageSize?: (size: number) => void;
  className?: string;
}) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  if (total <= pageSize && page === 1 && !sizes) return null;
  const from = total ? (page - 1) * pageSize + 1 : 0;
  const to = Math.min(total, page * pageSize);
  return (
    <div className={cx("flex flex-wrap items-center gap-3 px-4 py-2.5 border-t border-border text-[12.5px] text-fg-muted", className)}>
      <span className="tabular-nums">{fmtNumber(from)}–{fmtNumber(to)} {t("von")} {fmtNumber(total)}</span>
      {sizes && onPageSize && (
        <select aria-label={t("Einträge je Seite")} value={pageSize} onChange={(e) => onPageSize(Number(e.target.value))} className="h-7 rounded-md border border-border bg-surface px-1.5 text-[12px]">
          {sizes.map((s) => <option key={s} value={s}>{s} {t("je Seite")}</option>)}
        </select>
      )}
      {pages > 1 && (
        <div className="ml-auto flex items-center gap-1">
          <Button size="sm" variant="ghost" disabled={page <= 1} onClick={() => onPage(1)} aria-label={t("Erste Seite")}>«</Button>
          <Button size="sm" variant="ghost" disabled={page <= 1} onClick={() => onPage(page - 1)}>{t("‹ Zurück")}</Button>
          <span className="tabular-nums px-1">{fmtNumber(page)} / {fmtNumber(pages)}</span>
          <Button size="sm" variant="ghost" disabled={page >= pages} onClick={() => onPage(page + 1)}>{t("Weiter ›")}</Button>
          <Button size="sm" variant="ghost" disabled={page >= pages} onClick={() => onPage(pages)} aria-label={t("Letzte Seite")}>»</Button>
        </div>
      )}
    </div>
  );
}
